import { render, staticRenderFns } from "./BarcodeSetting.vue?vue&type=template&id=64e54c57&"
import script from "./BarcodeSetting.vue?vue&type=script&lang=ts&"
export * from "./BarcodeSetting.vue?vue&type=script&lang=ts&"
import style0 from "./BarcodeSetting.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports